import { render } from "./ProvidersList.vue?vue&type=template&id=1f9f4012&scoped=true"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"

import "./ProvidersList.vue?vue&type=style&index=0&id=1f9f4012&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f9f4012"

export default script